import * as api from "@nens/threedi/openapi-client";

import { AppState, Thunk } from "../App";

import { BACK_TO_START_SCREEN, BackToStartScreen } from "./appState";
import { getExistingRasterEdits } from "./existingEvents";

interface ExistingRasterEdits {
  selected: api.RasterEdit | null;
}

const INITIAL_STATE: ExistingRasterEdits = {
  selected: null,
};

export const getSelected = (state: AppState) => state.existingRasterEdits.selected;

const SET_SELECTED = "existingRasterEdits/SET_SELECTED";
const REMOVE_SELECTED = "existingRasterEdits/REMOVE";

interface SetSelected {
  type: typeof SET_SELECTED;
  rasterEdit: api.RasterEdit | null;
}
interface RemoveSelected {
  type: typeof REMOVE_SELECTED;
}

export const setSelected =
  (selectedUid: string | null): Thunk =>
  (dispatch, getState) => {
    const existingRasterEdits = getExistingRasterEdits(getState());
    if (!existingRasterEdits) return;

    const rasterEdit = existingRasterEdits.find((edit) => edit.uid === selectedUid);

    dispatch({
      type: SET_SELECTED,
      rasterEdit: rasterEdit || null,
    });
  };
export const removeSelected = () => {
  return {
    type: REMOVE_SELECTED,
  };
};

type ExistingRasterEditAction = SetSelected | RemoveSelected | BackToStartScreen;

export default function reducer(state = INITIAL_STATE, action: ExistingRasterEditAction) {
  switch (action.type) {
    case BACK_TO_START_SCREEN:
      return INITIAL_STATE;
    case SET_SELECTED:
      return {
        selected: action.rasterEdit,
      };
    case REMOVE_SELECTED:
      return {
        selected: null,
      };
    default:
      return state;
  }
}
